import { Link } from "react-router-dom";
import { Rocket, Package, Clock, Sparkles, Send, Lock } from "lucide-react";

import { _t } from "@/lib/i18n";
function Nav() {
  return (
    <header className="glass-header sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <Rocket className="w-5 h-5 text-[#FF5722] -rotate-45" />
          <div className="font-display text-2xl text-white">{_t("Time Capsule")}</div>
        </Link>
        <nav className="hidden md:flex items-center gap-2 text-sm">
          <Link to="/come-funziona" className="px-3 py-2 text-[#FF5722]">{_t("Come funziona")}</Link>
          <Link to="/prezzi" className="px-3 py-2 text-white/70 hover:text-white">{_t("Prezzi")}</Link>
          <Link to="/sicurezza" className="px-3 py-2 text-white/70 hover:text-white">{_t("Sicurezza")}</Link>
          <Link to="/faq" className="px-3 py-2 text-white/70 hover:text-white">{_t("FAQ")}</Link>
        </nav>
        <div className="flex gap-3">
          <Link to="/login" className="btn-ghost">{_t("Accedi")}</Link>
          <Link to="/register" className="btn-launch">{_t("Inizia")}</Link>
        </div>
      </div>
    </header>
  );
}

export default function HowItWorks() {
  const steps = [
    { icon: <Package />, title: _t("1. Scegli il tipo"), body: _t("Otto categorie: per i figli, i nipoti, un amore, i posteri, o personalizzata. Ogni scelta guida il tono della capsula.") },
    { icon: <Send />, title: _t("2. Aggiungi destinatari"), body: _t("Uno o più. Con nome, email, relazione e un messaggio personale per ciascuno. Decidi se avvisarli subito o solo al momento dell'apertura.") },
    { icon: <Clock />, title: _t("3. Imposta la data"), body: _t("Da domani a 30 anni nel futuro. Data, ora e fuso orario. La capsula si aprirà automaticamente.") },
    { icon: <Sparkles />, title: _t("4. Aggiungi contenuti"), body: _t("Testo, foto, video, audio, documenti, link. Riordina, personalizza titolo e descrizione di ogni elemento.") },
    { icon: <Rocket />, title: _t("5. Lancia"), body: _t("Un conto alla rovescia di 10 secondi. Al Decollo la capsula entra nel periodo di ripensamento (24h) in cui puoi annullare.") },
    { icon: <Lock />, title: _t("6. Sigilla il tempo"), body: _t("Dopo le 24h la capsula è sigillata. Non potrai più aprirla, modificarla o recuperarla. Neanche noi.") },
  ];
  return (
    <div className="min-h-screen">
      <Nav />
      <section className="max-w-5xl mx-auto px-6 py-24">
        <div className="text-[11px] uppercase tracking-[0.3em] text-[#FF5722] mb-4">{_t("Come funziona")}</div>
        <h1 className="font-display text-6xl md:text-7xl text-white leading-tight mb-8">{_t("Sei passi. Un decollo.")}</h1>
        <p className="text-lg text-white/70 max-w-2xl mb-16">{_t("Time Capsule è un rituale digitale: prepari, sigilli, aspetti. Alla fine, qualcuno riceve una parte del tuo presente in un momento del futuro.")}</p>

        <div className="grid md:grid-cols-2 gap-6">
          {steps.map((s, i) => (
            <div key={i} className="tc-card p-7">
              <div className="w-10 h-10 rounded-full bg-[#FF5722]/15 border border-[#FF5722]/30 flex items-center justify-center text-[#FF5722] mb-4">
                {s.icon}
              </div>
              <div className="font-display text-2xl text-white mb-2">{s.title}</div>
              <div className="text-sm text-white/60 leading-relaxed">{s.body}</div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <Link to="/register" className="btn-launch !text-base"><Rocket className="w-4 h-4 -rotate-45" />{" "}{_t("Provalo ora")}</Link>
        </div>
      </section>
    </div>
  );
}
